export default {
  PERFORM_INIT_API: '/theatreabove/performDetail',
  GET_ACTOR_DETAIL: actorId => `/theatreabove/actorDetail/${actorId}`,
  SCHEDULES_INIT_API: '/theatreabove/schedules',
  SERIES_INIT_API: '/theatreabove/series',
  SEAT_INIT_API: sid => `/theatreabove/seatMapCombined/${sid}`,
  SEAT_SELECT_API: '/theatreabove/selectSeat',
  USER_INFO: '/theatreabove/user',
  NEWS: '/theatreabove/news',
  NEW_DETAIL: newId => `/theatreabove/newsDetail/${newId}`,
  USER_OTP: '/theatreabove/otp',
  LOGIN: '/theatreabove/login',
  LOGOUT: '/theatreabove/logout',
  REGISTER: '/theatreabove/register',
  FIND_PASSWORD: '/theatreabove/findPassword',
  MODIFY_PASSWORD: '/theatreabove/modifyPassword',
  MY_INFO_API: '/theatreabove/myInfo',
  DELETE_ORDER_API: '/theatreabove/deleteOrder',
  ORDER_DETAIL: '/theatreabove/orderDetail',
  ORDER_CONFIRM: '/theatreabove/orderConfirm',
  DELETE_PERFORM: '/theatreabove/deletePerform',
  PAY: '/theatreabove/checkout',
  HOME_BANNER: '/theatreabove/banners',
  HOME_CARD: '/theatreabove/cards',
  HOME_DATA: '/theatreabove/homeData',
  HC_HOME_DATA: '/theatreabove/HChomeData',
  PAY_ORDER: orderId => `/theatreabove/payOrder/${orderId}`,
  DELETE_ORDER: '/theatreabove/deleteOrder',
  COUPON_DETAIL_API: '/theatreabove/couponDetail',
  FAQ: '/theatreabove/faq',
  SESSION_INFO: sessionId => `/theatreabove/sessionInfo/${sessionId}`,
  EVENT_MEMBER: '/theatreabove/eventMember',
  EVENT_STUDY: '/theatreabove/eventStudy',
  EVENT_GUEST: '/theatreabove/eventGuest',
  EVENT_LECTURE: '/theatreabove/eventLecture',
  AUTO_BOOK: sessionId => `/theatreabove/autoBook/${sessionId}`,
  EVENT_CARD: '/theatreabove/events',
  REFUND_CHECK: '/theatreabove/refundCheck',
  REFUND_SUBMIT: '/theatreabove/refundSubmit',
  VOUCHER_CHECK: '/theatreabove/voucherCheck',
  VOUCHER_SUBMIT: '/theatreabove/voucherSubmit',
}



// WEBPACK FOOTER //
// ./src/constants/apis.js